export default __webpack_public_path__ + "static/media/Leg_left.20258e1d.svg";